import { createAction } from 'redux-actions';

import { API_SECURITY } from 'constants/endpoints';
import { StatusEnum } from 'flex/actions/http/StatusEnum';

/**
 * Prefix 付きの ActionType を作成する
 */
const createActionType = <ActionType extends string>(actionType: ActionType) => {
    const prefix = 'CONNECTION/SECURITY';
    return `${prefix}/${actionType}` as `${typeof prefix}/${ActionType}`;
};

type DefaultPayload = { method: HttpMethods, api: string };
type DefaultMeta = { fetch: boolean, status: RequestStatus };

type Payload<EXTRA extends Record<string, unknown> = Record<string, never>> =
    EXTRA extends Record<string, never> ?
    DefaultPayload :
    Expand<DefaultPayload & EXTRA>;

type Meta<EXTRA extends Record<string, unknown> = Record<string, never>> =
    EXTRA extends Record<string, never> ?
    DefaultMeta :
    Expand<DefaultMeta & EXTRA>;

/** セキュリティ設定全体 取得 */
export const getSettings = createAction(
    createActionType('GET_SETTINGS' as const),
    () => ({
        api: `${API_SECURITY}/setting`,
        method: 'get',
    }),
    () => ({ fetch: true, status: StatusEnum.REQUEST })
);

/** セキュリティ設定全体 更新 */
export const updateSettings = createAction<
    Payload,
    Meta,
    {
        security_setting: {
            enable_mfa: boolean;
            expire_mfa_hour: number;
            require_mfa_control: boolean;
            require_mfa_admin: boolean;
            require_mfa_permission: {
                administrator: boolean;
                school_administrator: boolean;
                teacher: boolean;
                student: boolean;
            };
            reauth_grace_period_enabled: boolean;
            reauth_grace_period: number;
        };
        mfa_allowed_ips: { setting: string; comment: string; }[];
        control_ip_filters: { setting: string; comment: string; }[];
        control_ip_filters_enabled: boolean;
        admin_ip_filters: { setting: string; comment: string; }[];
        admin_ip_filters_enabled: boolean;
    }
>(
    createActionType('UPDATE_SETTINGS' as const),
    (data) => ({
        api: `${API_SECURITY}/setting`,
        data,
        method: 'post',
    }),
    (_data) => ({ fetch: true, status: StatusEnum.REQUEST })
);
